/** Value vocabularies shared by the kit and every feature. */
import type { SimFeatureId } from "./flags";
import type { SimMarket, SimPersona, SimRegion, SimScenario } from "./types";

export const SCENARIOS: readonly { id: SimScenario; label: string; hint: string }[] = [
  { id: "normal", label: "Normal day", hint: "Calendar-based season tips only" },
  { id: "typhoon", label: "Typhoon", hint: "Signal No. 2 expected tonight (simulated storm)" },
  { id: "heavyRain", label: "Heavy rain", hint: "Flooding in low-lying areas; classes may be suspended" },
  { id: "dengue", label: "Dengue alert", hint: "Cases rising in your area" },
  { id: "backToSchool", label: "Back to school", hint: "School-opening week" },
  { id: "heat", label: "Heat wave", hint: "Hot, dry days with a high heat index" },
];

export interface RegionInfo {
  id: SimRegion;
  /** Lowercase id accepted by ?region= */
  short: string;
  island: "Luzon" | "Visayas" | "Mindanao";
  /** How often typhoons make direct landfall — drives typhoon vs heavy-rain prep. */
  typhoonExposure: "high" | "medium" | "low";
}

export const REGIONS: readonly RegionInfo[] = [
  { id: "Metro Manila", short: "manila", island: "Luzon", typhoonExposure: "medium" },
  { id: "Cebu City", short: "cebu", island: "Visayas", typhoonExposure: "medium" },
  { id: "Davao City", short: "davao", island: "Mindanao", typhoonExposure: "low" },
  { id: "Tacloban City", short: "tacloban", island: "Visayas", typhoonExposure: "high" },
  { id: "Iloilo City", short: "iloilo", island: "Visayas", typhoonExposure: "medium" },
  { id: "Baguio City", short: "baguio", island: "Luzon", typhoonExposure: "medium" },
];

export const PERSONAS: readonly { id: SimPersona; label: string; hint: string }[] = [
  { id: "firstWeek", label: "First week", hint: "Joined two days ago — first-week journey on" },
  { id: "regular", label: "Regular", hint: "Member since June — streaks and weekly recaps" },
];

/** Sim Panel labels (manifests may not be loaded for features that are off). */
export const FEATURE_LABELS: Record<SimFeatureId, string> = {
  welcome: "Welcome & tour",
  shop: "Shop & cart",
  community: "Community wall",
  safeSpace: "Safe space",
  stories: "Stories & best-practice guides",
  registry: "Baby registry",
  dailyWins: "Daily wins",
  seasonal: "Season alerts (PH)",
  partners: "Partners",
  directory: "Schools & clinics",
};

/** The two versions of the product. The PH market adds season cards and PH crisis lines. */
export const MARKETS: readonly { id: SimMarket; label: string; hint: string }[] = [
  { id: "main", label: "United States & elsewhere", hint: "Main market: no seasonal content" },
  { id: "ph", label: "Philippines", hint: "Leena's List Philippines: season cards, PH hotlines, ₱" },
];
